import addError from '../../../utils/error.jsx';

export function request(id, eventId) {
    id = parseInt(id, 10);
    return {
        type: 'MARKETS_GET_LIABILITIES_REQUEST',
        eventId,
        id
    };
}

export function error(id, errors) {
    addError(errors);

    return {
        type: 'MARKETS_GET_LIABILITIES_ERROR',
        errors,
        id
    };
}

export function finish(id, liabilities) {
    return {
        type: 'MARKETS_GET_LIABILITIES_FINISH',
        liabilities,
        id
    };
}
